import {SVG} from '@svgdotjs/svg.js';
import axios from 'axios';
import $ from 'jquery';
import _ from 'lodash';
import {getConfig} from './configUtil';

export async function getZoneAndBedsNameFromOldMapUHD(refContainer, refContainerElement, onlyPoole = false, onlyRbh = false) {
    const zones = [];
    const hospitals = getConfig('modules.map.customMapConfig', []);
    const mapPaths = [];

    hospitals.forEach(hospital => {
        mapPaths.push({
            id: hospital.shortName?.toLowerCase(),
            path: `/maps/${hospital.mapPath}/ed_geo.svg`,
        });
    });

    if (!onlyRbh) {
        await getMapData(mapPaths[0].path, refContainer, refContainerElement, mapPaths[0].id)
            .then(data => {
                zones.push(...data);
            });
    }

    if (!onlyPoole) {
        await getMapData(mapPaths[1].path, refContainer, refContainerElement, mapPaths[1].id)
            .then(data => {
                zones.push(...data);
            });
        if (mapPaths.length > 2) {
            await getMapData(mapPaths[2].path, refContainer, refContainerElement, mapPaths[2].id)
                .then(data => {
                    zones.push(...data);
                });
        }
    }
    return zones;
}

const getMapData = (mapPath, refContainer, refContainerElement, hospital) => {
    return new Promise((resolve, reject) => {
        axios
            .get(mapPath)
            .then(function (response) {
                $(refContainer.current).html('');
                let element = SVG()?.addTo(refContainer.current);
                refContainerElement.current = element;
                element.id('svg-container');

                let draw = element.size(0, 0);
                var group = draw.group();
                let svgDocumentDOM = group.svg(response.data);
                const vb = svgDocumentDOM.findOne('svg').viewbox();
                const nvb =
                    vb.x -
                    20 +
                    ' ' +
                    (vb.y - 20) +
                    ' ' +
                    (vb.width + 40) +
                    ' ' +
                    (vb.height + 40);
                svgDocumentDOM.findOne('svg').viewbox(nvb);
                const findObjects = (typeName, areaToAdd, allPatients) => {
                    function parse(dataName) {
                        let obj = {};
                        let splitted = _.split(dataName.substring(2), '$');

                        // eslint-disable-next-line default-case
                        switch (splitted[0]) {
                            case 'g':
                                obj = {
                                    type: 'group',
                                    name: splitted[1],
                                    params: _.slice(splitted, 2),
                                };
                                break;
                            case 'b':
                                obj = {
                                    type: 'bed',
                                    name: splitted[1],
                                    params: _.slice(splitted, 2),
                                };
                                break;
                            case 'z':
                                obj = {
                                    type: 'zoom',
                                    name: splitted[1],
                                    params: _.slice(splitted, 2),
                                };
                                break;
                            case 'wait':
                                obj = {
                                    type: 'wait',
                                    name: splitted[1],
                                    params: _.slice(splitted, 2),
                                };
                                break;
                        }

                        return obj;
                    }

                    let foundedElements = group.find(typeName);
                    for (let element of foundedElements) {
                        if ((!element.attr('data-name') || (element.attr('data-name') && !_.startsWith(element.attr('data-name'), '$$')))
                            && element.attr('id') && element.attr('data-name') !== 'WAITING' && element.attr('id') !== 'WAITING') {
                            let foundedTitle = element.find('text');
                            if (foundedTitle.length !== 0) {
                                let areaTitle = '';
                                for (let title of foundedTitle) {
                                    if (title.node.children.length !== 0) {
                                        title.node.childNodes?.forEach((ch) => areaTitle += ch.innerHTML ? ch.innerHTML : ch.data);
                                    } else
                                        areaTitle = title.node.innerHTML;
                                }
                                let foundedBed = element.find('rect');
                                let beds = [];
                                for (let elementBed of foundedBed) {
                                    const dataName = elementBed.attr('data-name');
                                    if (_.startsWith(dataName, '$$')) {
                                        beds.push({
                                            name: dataName,
                                            parsed: parse(dataName),
                                        });
                                    }
                                }
                                areaToAdd.push({
                                    beds,
                                    areaTitle,
                                    dataName: element.attr('id'),
                                    hospital,
                                });
                            }
                        }

                        if (element.attr('data-name') === 'WAITING' || element.attr('id') === 'WAITING') {
                            let foundedTitle = element.find('text');
                            if (foundedTitle) {
                                let areaTitle = '';
                                for (let title of foundedTitle) {
                                    if (title.node.children.length !== 0) {
                                        title.node.childNodes?.forEach((ch) => {
                                            if (ch.childNodes) {
                                                ch.childNodes?.forEach((ch2) => {
                                                    areaTitle += ch2.innerHTML ? ch2.innerHTML : ch2.data;
                                                });
                                            } else {
                                                areaTitle += ch.innerHTML ? ch.innerHTML : ch.data;
                                            }

                                        });
                                    } else
                                        areaTitle = title.node.innerHTML;
                                }

                                let foundedBed = element.find('g');
                                let beds = [];
                                for (let elementBed of foundedBed) {
                                    const dataName = elementBed.attr('data-name');
                                    if (_.startsWith(dataName, '$$w')) {
                                        beds.push({
                                            name: dataName,
                                            parsed: parse(dataName),
                                        });
                                    }
                                }
                                areaToAdd.push({
                                    beds,
                                    areaTitle,
                                    dataName: element.attr('id'),
                                    hospital,
                                });
                            }
                        }
                    }
                };

                let allAreas = [];
                let allPatients = [];

                findObjects('g', allAreas, allPatients);
                resolve(allAreas);
            });
    });
};